<template>
    <div class="night hml_whplt">
        <swiperList :swiperStyle="{padding: '1.29rem .4rem .5rem'}" :setSwiperNumFlag="true">
            <li
            class="nightlide"
            v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
            :key="index"
            @click="nightlideClick(index)"
            >
                <img :src="item.thumb">
                <div class="textContent">
                    <!-- <div class="xian"></div> -->
                    <h2 class="title"><i></i><span>{{ item.title }}</span><i></i></h2>
                    <!-- <div class="xian"></div>
                    <p>{{ item.description }}</p> -->
                </div>
            </li>
        </swiperList>
    </div>
</template>

<script>

import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    methods: {
        nightlideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/panorama");
        },
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex'])
    }
}
</script>

<style lang="scss" scoped>
.night{
    // padding-top: .92rem;
    .nightlide{
        width: 6.7rem;
        height: 2.68rem;
        // box-shadow:0px .13rem .27rem 0px rgba(0, 0, 0, 0.24);
        position: relative;
        // overflow: hidden;
        display: flex;
        margin-bottom: .3rem;
        img{
            width: 100%;
            height: 2.4rem;
            border-radius: .1rem;
            // position: absolute;
            // left: 0;
            // top: 0;
            // z-index: 1;

        }
        .textContent{
                
            h2{
                width: 6.24rem;
                height: .76rem;
                background: rgba(255,255,255,.95);
                box-shadow: 0px .13rem .27rem 0px rgba(0, 0, 0, 0.18);
                border-radius: .06rem .5rem .06rem .5rem;
                font-size: .36rem;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                font-family: "siyuan";
                font-weight: bold;
                display: flex;
                align-items: center;
                justify-content: center;
                i{
                    width: .68rem;
                    height: 1px;
                    background: #000;
                }
                span{
                    margin: 0 .2rem;
                    // display: block;
                    // position: relative;
                    // text-align: center;
                    // line-height: .76rem;
                   
                }
            }
            .xian{
                width: 3.75rem;
                height: 1px;
                background: #000;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
            }
            p{
                color: #999;
                font-size: .22rem;
                line-height: .34rem;
                margin-left: .6rem;
                padding-right: .14rem;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
        }
        /*
        .textContent{
            background: linear-gradient(to right,rgba(0,0,0,.6),rgba(0,0,0,0));
            padding-left: .42rem;
            padding-top: .67rem;
            h2{
                font-size: .5rem;
                color: #fff;
            }
            .xian{
                width: 3.6rem;
                height: .01rem;
                background: #fff;
                margin: .16rem 0;
            }
            .keywordsList{
                display: flex;
                align-items: center;
                margin-top: .2rem;
                li{
                    font-size: .22rem;
                    color: #fff;
                }
            }
        } */
    }
}
</style>